import { MetodoPagamentoVendaEnum } from '../types/enums/metodo-pagamento.enum';
import { MoedaVendaEnum } from '../types/enums/moeda-venda.enum';
import { cardMpStrategy } from './card-mp.strategy';
import { cardStripeStrategy } from './card-stripe.strategy';
import { pixStrategy } from './pix.strategy';
import { boletoStrategy } from './boleto.strategy';
import { paypalStrategy } from './paypal.strategy';
import { applePayStrategy } from './apple-pay.strategy';
import { googlePayStrategy } from './google-pay.strategy';
import { amazonPayStrategy } from './amazon-pay.strategy';

export const paymentStrategyMap = {
  [MetodoPagamentoVendaEnum.CARTAO_CREDITO]: async (ctx: any) => {
    if (
      ctx.checkout?.moeda === MoedaVendaEnum.BRL &&
      !ctx.checkout?.recorrencia
    ) {
      return cardMpStrategy(ctx);
    }
    return cardStripeStrategy(ctx);
  },
  [MetodoPagamentoVendaEnum.PIX]: pixStrategy,
  [MetodoPagamentoVendaEnum.BOLETO]: boletoStrategy,
  [MetodoPagamentoVendaEnum.PAY_PAL]: paypalStrategy,
  [MetodoPagamentoVendaEnum.APPLE_PAY]: applePayStrategy,
  [MetodoPagamentoVendaEnum.GOOGLE_PAY]: googlePayStrategy,
  [MetodoPagamentoVendaEnum.AMAZON_PAY]: amazonPayStrategy,
};
